module.exports = __webpack_public_path__ + "static/img/2areaA_39.6f5f306.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/2areaA_39.png
// module id = 811
// module chunks = 1